import { useGenericRequestHandler } from '../../../handlers/useGenericRequestHandler'

export const useMoteDeleteMutation = (moteId) => {
  return useGenericRequestHandler({
    route: `m/delete/${moteId}`,
    method: 'POST'
  })
}
